module.exports = __webpack_public_path__ + "static/media/weth.30df78a7.svg";